'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var umiSerializers = require('@metaplex-foundation/umi-serializers');

/** @deprecated import from "@metaplex-foundation/umi/serializers" instead. */

/** @deprecated import from "@metaplex-foundation/umi/serializers" instead. */
const mapSerializer = umiSerializers.mapSerializer;

/** @deprecated import from "@metaplex-foundation/umi/serializers" instead. */
const fixSerializer = umiSerializers.fixSerializer;

/** @deprecated import from "@metaplex-foundation/umi/serializers" instead. */
const reverseSerializer = umiSerializers.reverseSerializer;

/** @deprecated import from "@metaplex-foundation/umi/serializers" instead. */
const mergeBytes = umiSerializers.mergeBytes;

/** @deprecated import from "@metaplex-foundation/umi/serializers" instead. */
const padBytes = umiSerializers.padBytes;

/** @deprecated import from "@metaplex-foundation/umi/serializers" instead. */
const fixBytes = umiSerializers.fixBytes;

/** @deprecated import from "@metaplex-foundation/umi/serializers" instead. */
const utf8 = umiSerializers.utf8;

/** @deprecated import from "@metaplex-foundation/umi/serializers" instead. */
const baseX = umiSerializers.baseX;

/** @deprecated import from "@metaplex-foundation/umi/serializers" instead. */
const base10 = umiSerializers.base10;

/** @deprecated import from "@metaplex-foundation/umi/serializers" instead. */
const base58 = umiSerializers.base58;

/** @deprecated import from "@metaplex-foundation/umi/serializers" instead. */
const base64 = umiSerializers.base64;

/** @deprecated import from "@metaplex-foundation/umi/serializers" instead. */
const base16 = umiSerializers.base16;

/** @deprecated import from "@metaplex-foundation/umi/serializers" instead. */
const bitArray = umiSerializers.bitArray;

/** @deprecated import from "@metaplex-foundation/umi/serializers" instead. */
const removeNullCharacters = umiSerializers.removeNullCharacters;

/** @deprecated import from "@metaplex-foundation/umi/serializers" instead. */
const padNullCharacters = umiSerializers.padNullCharacters;

/** @deprecated import from "@metaplex-foundation/umi/serializers" instead. */

/** @deprecated import from "@metaplex-foundation/umi/serializers" instead. */
const Endian = umiSerializers.Endian;

/** @deprecated import from "@metaplex-foundation/umi/serializers" instead. */

exports.Endian = Endian;
exports.base10 = base10;
exports.base16 = base16;
exports.base58 = base58;
exports.base64 = base64;
exports.baseX = baseX;
exports.bitArray = bitArray;
exports.fixBytes = fixBytes;
exports.fixSerializer = fixSerializer;
exports.mapSerializer = mapSerializer;
exports.mergeBytes = mergeBytes;
exports.padBytes = padBytes;
exports.padNullCharacters = padNullCharacters;
exports.removeNullCharacters = removeNullCharacters;
exports.reverseSerializer = reverseSerializer;
exports.utf8 = utf8;
//# sourceMappingURL=serializersInternal.cjs.map
